import { render, staticRenderFns } from "./WorkDetailTaskItem.vue?vue&type=template&id=43dc61bd&scoped=true"
import script from "./WorkDetailTaskItem.vue?vue&type=script&lang=js"
export * from "./WorkDetailTaskItem.vue?vue&type=script&lang=js"
import style0 from "./WorkDetailTaskItem.vue?vue&type=style&index=0&id=43dc61bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dc61bd",
  null
  
)

export default component.exports